import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { ShieldCheck, Loader2, Check } from "lucide-react";

const MATRIX = [
  { res: "物件・部屋・入居者・契約・修繕", roles: { company_admin: true, property_manager: true, accountant: false, viewer: false } },
  { res: "貸主管理", roles: { company_admin: true, property_manager: true, accountant: false, viewer: false } },
  { res: "家賃入金・経費・ローン・収支", roles: { company_admin: true, property_manager: false, accountant: true, viewer: false } },
  { res: "ユーザー・権限・会社設定", roles: { company_admin: true, property_manager: false, accountant: false, viewer: false } },
  { res: "全データ閲覧", roles: { company_admin: true, property_manager: true, accountant: true, viewer: true } },
];
const COLS = [
  { key: "company_admin", label: "会社管理者" },
  { key: "property_manager", label: "管理担当" },
  { key: "accountant", label: "経理担当" },
  { key: "viewer", label: "閲覧" },
];

export default function SettingsRoles() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/settings/roles").then(({ data }) => setRoles(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="animate-fade-in">
      <PageHeader title="権限設定" subtitle="ロールベースアクセス制御（RBAC）" />
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
            {roles.map((r) => (
              <div key={r.key} className="bg-white border border-border rounded-sm p-5" data-testid={`role-${r.key}`}>
                <div className="w-9 h-9 bg-brand-soft rounded-sm flex items-center justify-center mb-3">
                  <ShieldCheck className="w-5 h-5 text-brand" />
                </div>
                <div className="font-medium mb-1">{r.name}</div>
                <div className="text-sm text-muted-foreground">{r.desc}</div>
              </div>
            ))}
          </div>

          <div className="bg-white border border-border rounded-sm overflow-hidden">
            <div className="px-5 py-3 border-b bg-gray-50 text-sm font-medium">権限マトリクス</div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b text-xs uppercase text-muted-foreground">
                    <th className="px-4 py-3 text-left">機能</th>
                    {COLS.map((c) => <th key={c.key} className="px-4 py-3 text-center">{c.label}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {MATRIX.map((row, i) => (
                    <tr key={i} className="border-b last:border-0">
                      <td className="px-4 py-3">{row.res}</td>
                      {COLS.map((c) => (
                        <td key={c.key} className="px-4 py-3 text-center">
                          {row.roles[c.key] ? <Check className="w-4 h-4 text-emerald-600 mx-auto" /> : <span className="text-gray-300">—</span>}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
